<template>
    <main class="SectionRegister-MAIN">
        <img src="../assets/arrow-back.png"/>
        <h1>Registro</h1>
        <hr>
        <p>
            Ingrese sus datos para registrarse en ap(art).
        </p>

        <b>Nombre:</b>
        <input type="text" placeholder="" v-model="form.name" :disabled="loading"/>
        <b>Instagram:</b>
        <input type="text" placeholder="@usuario" v-model="form.instagram" :disabled="loading"/>
        <b>Correo:</b>
        <input type="email" placeholder="correo@dominio.com" v-model="form.email" :disabled="loading"/>
        <b>Contraseña:</b>
        <input type="password" placeholder="********" v-model="form.password" :disabled="loading"/>
        <p v-if="errorMsg" class="error-msg">{{ errorMsg }}</p>

        <button @click="register()" :disabled="loading">REGISTRARSE</button>
    </main>
</template>

<script>
export default {
    name: 'SectionRegister',
    data(){
        return{
            form: {
                name: '',
                instagram: '',
                email: '',
                password: '',
            },
            loading: false,
            errorMsg: '',
        }
    },
    methods: {
        async register(){
            this.loading = true;
            try {
                const response = await fetch(`${this.$ENDPOINT}/api/register.php`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        name: this.form.name,
                        instagram: this.form.instagram,
                        email: this.form.email,
                        password: this.form.password
                    })
                });
                const result = await response.json();

                if(result.status == 'success') {
                    localStorage.setItem('token', result.token);
                    localStorage.setItem(
                        'userData',
                        JSON.stringify(result.user)
                    );
                    this.$router.push('/');
                } else {
                    console.log(result);
                    const err = result.errors;
                    if(err.password) this.errorMsg = err.password;
                    if(err.email) this.errorMsg = err.email;
                }
            } catch(error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },
    }
}
</script>

<style scoped lang="stylus">
.SectionRegister-MAIN
    display: flex
    flex-direction: column
    padding: 10px
    width: calc(100% - 20px)
    min-height: calc(100vh - 20px)
    background-color: white

    >img
        width: 8vw
        margin-bottom: 2vw

    >h1
        font-family: "Archivo ExtraCondensed", sans-serif
        text-transform: uppercase
        font-size: 12vw
        text-wrap: balance
        margin-bottom: 0

    >hr
        width: 100%
        border: 1px solid black

    >p
        font-family: "Archivo ExtraCondensed", sans-serif
        margin-top: 0
        font-size: 6vw
        color: #B0B0B0
        margin-bottom: 8vh

        >span
            color: black
            text-decoration: underline

     >button
        height: 47px
        width: calc(180px + 18px + 18px)
        background-color: rgb(1, 90, 255)
        color: white
        max-width: 75vw
        position: fixed
        margin: auto
        left: 0
        right: 0
        bottom: 6vw
        border-radius: 100vw
        z-index: 1
        font-family: "DM Mono", monospace
        border: none

    /* inputs */
    >b
        font-family: "Archivo ExtraCondensed", sans-serif
        font-size: 6.5vw
        text-transform: uppercase
        color: black

    >input
        font-family: "Archivo ExtraCondensed", sans-serif
        padding: 2vw 0
        margin-bottom: 4vh
        border: none
        border-bottom: 1px solid black
        font-size: 5vw

        &::placeholder
            color: #C3C3C3
            font-size: 6vw

    /* error msg */
    .error-msg
        color: rgb(1, 90, 255)
        font-family: "Archivo ExtraCondensed", sans-serif
        font-weight: 100
        font-size: 4.4vw
        margin-bottom: 0
        margin-top: 0 !important
        color: red !important
</style>